import { render, staticRenderFns } from "./BaseWarningDialog.vue?vue&type=template&id=d0d4a1a4&"
import script from "./BaseWarningDialog.vue?vue&type=script&lang=js&"
export * from "./BaseWarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseWarningDialog.vue?vue&type=style&index=0&id=d0d4a1a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports